import * as o from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/Microphone.es.js";
const e = o.forwardRef((r, c) => /* @__PURE__ */ o.createElement(t, { ref: c, ...r, weights: n }));
e.displayName = "MicrophoneIcon";
const m = e;
export {
  m as Microphone,
  e as MicrophoneIcon
};
